<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               :title="this.type"
               size="30%"
               :before-close="handleClose"
               :visible.sync="drawer"
               direction="rtl"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
    >

      <div class="demo-drawer__content">
        <el-form :model="formData" v-if="this.type==='作废'">
          <em class="f-red" style="float: left">*</em>
          <el-form-item label="备注">
            <el-input type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8}"
                      v-model="formData.remark"
                      autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <span v-else>确认{{this.type}}【{{this.confirmNo}}】吗？</span>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="close">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import api from "@/api/projectApi";

export default {
  name: 'edit',
  props: ['visiable', 'multi', 'dataId', 'type', 'confirmNo'],
  created() {
    this.formData.id = this.dataId
    this.formData.statName = this.type
  },
  data() {
    return {
      formData: {
        remark: null,
        id: null,
        statName: null
      },
      drawer: true,
    }
  },
  methods: {
    // 关闭
    close() {
      if (this.type == '作废' && !this.formData.remark) {
        this.$message.warning('请填写备注')
      } else {
        this.$http({
          url: api.wkQualityReport.confirmDataUrl,
          method: 'post',
          data: this.formData
        }).then(res => {
          //this.$message.success('操作成功');
          if (res.data.type == "success") {
            this.$message({message: res.data.content, type: 'success'});
          } else {
            this.$message({message: res.data.content, type: 'warning'});
          }
          this.cancelForm()
          this.$emit('goBackIndex')
        })
      }
    },




    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.visiable = false;
      this.$emit('update:visiable', this.visiable)
    },
    handleClose() {
      this.cancelForm()
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
